<template>
  <div>
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
import Chart from './chart.vue';
import axios from 'axios';
export default {
  data() {
    return {
      cdata: {
        xData: ["涂布空货位", "涂布满货位", "箔材空货位", "箔材满货位"],
        seriesData: [
          { value: 5, name: "涂布空货位" },
          { value: 10, name: "涂布满货位" },
          { value: 15, name: "箔材空货位" },
          { value: 20, name: "箔材满货位" },

        ]
      }
    }
  },
  components: {
    Chart,
  },
  mounted() {
    this.changeTiming()
  },
  methods: {
    changeTiming() {
        this.changeNumber()
      setInterval(() => {
        this.changeNumber()
      }, 20000)
    },
    changeNumber() {
      axios.post("http://192.168.11.58:8098/api/ToWMS/GetLocationEmptyOrStored", {
      // axios.post("http://127.0.0.1:8098/api/ToWMS/GetLocationEmptyOrStored", {
        MainData: {
          AGVName: "正极AGV调度"
        }
      }).then((res) => {
        let agvs = res.data.data
        let GetLocationEmptyOrStored = [
          {value:agvs.tbEmptyNum,name:"涂布空货位"},
          {value:agvs.tbStoredNum,name:"涂布满货位"},
          {value:agvs.bcEmptyNum,name:"箔材空货位"},
          {value:agvs.bcStoredNum,name:"箔材满货位"},
        ]
        this.cdata.seriesData = GetLocationEmptyOrStored
      }).catch((res) => {
        console.log(res)
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>